import React, { memo } from "react";
import { Icon, IconProps } from "@chakra-ui/icon";

const CircleCheckIcon = (props: IconProps) => (
  <Icon w="16px" h="16px" viewBox="0 0 16 16" {...props}>
    <path d="M14.6666 3.45301L7.05998 11.0663L4.23331 8.23967L5.17331 7.29967L7.05998 9.18634L13.7266 2.51967L14.6666 3.45301ZM13.1933 6.81301C13.28 7.19301 13.3333 7.59301 13.3333 7.99967C13.3333 10.9463 10.9466 13.333 7.99998 13.333C5.05331 13.333 2.66665 10.9463 2.66665 7.99967C2.66665 5.05301 5.05331 2.66634 7.99998 2.66634C9.05331 2.66634 10.0266 2.97301 10.8533 3.49967L11.8133 2.53967C10.7333 1.77967 9.41998 1.33301 7.99998 1.33301C4.31998 1.33301 1.33331 4.31967 1.33331 7.99967C1.33331 11.6797 4.31998 14.6663 7.99998 14.6663C11.68 14.6663 14.6666 11.6797 14.6666 7.99967C14.6666 7.20634 14.52 6.44634 14.2666 5.73967L13.1933 6.81301Z" />
  </Icon>
);

export default memo(CircleCheckIcon);
